var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap" },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "违规记录ID号" } },
            [
              _c("el-input", {
                attrs: { placeholder: "违规记录ID号", clearable: "" },
                model: {
                  value: _vm.blacklistId,
                  callback: function($$v) {
                    _vm.blacklistId = _vm._n($$v)
                  },
                  expression: "blacklistId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "类型" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.platform,
                    callback: function($$v) {
                      _vm.platform = $$v
                    },
                    expression: "platform"
                  }
                },
                [
                  _c("el-option", {
                    key: "QualityControl",
                    attrs: { label: "质检平台", value: "QualityControl" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Forewarning",
                    attrs: { label: "预警平台", value: "Forewarning" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "CommonRule",
                    attrs: { label: "通用规则", value: "CommonRule" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.compositeState,
                    callback: function($$v) {
                      _vm.compositeState = $$v
                    },
                    expression: "compositeState"
                  }
                },
                [
                  _c("el-option", {
                    key: "Punished",
                    attrs: { label: "已扣罚", value: "Punished" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Appealable",
                    attrs: { label: "有疑议可申诉", value: "Appealable" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Appealing",
                    attrs: { label: "申诉中", value: "Appealing" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "AppealSuccess",
                    attrs: { label: "申诉成功", value: "AppealSuccess" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "AppealFail",
                    attrs: { label: "申诉失败", value: "AppealFail" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("查询")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "blacklistId", label: "违规记录ID", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "compositeStateValue",
              label: "状态",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "日期", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "platformName", label: "类型", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "shopName", label: "关联店铺", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "platformRuleContent",
              label: "违反规章",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "punishContent", label: "处罚内容", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "具体原因", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.platform == "QualityControl" &&
                    scope.row.thirdPlatformId.indexOf("offline_") < 0
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "link-text",
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function($event) {
                                  return _vm.jumpToInfo(scope.row)
                                }
                              }
                            },
                            [_vm._v("查看详情")]
                          )
                        ]
                      : [
                          scope.row.compositeState == "Appealing" ||
                          scope.row.compositeState == "AppealSuccess" ||
                          scope.row.compositeState == "AppealFail"
                            ? _c(
                                "span",
                                {
                                  staticClass: "link-text",
                                  on: {
                                    click: function($event) {
                                      return _vm.showResultModal(
                                        scope.row.blacklistId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("查看详情")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.compositeState == "Appealable" &&
                          "QualityControl" !== scope.row.platform
                            ? _c(
                                "span",
                                {
                                  staticClass: "link-text",
                                  on: {
                                    click: function($event) {
                                      return _vm.showModal(
                                        scope.row.blacklistId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("申诉")]
                              )
                            : _vm._e()
                        ]
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
        on: { getData: _vm.getList }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申诉原因",
            visible: _vm.dialogVisible,
            width: "50%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modal",
              attrs: {
                model: _vm.modal,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "is-required", attrs: { label: "上传图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: "//upload-z0.qiniup.com",
                        "list-type": "picture-card",
                        "on-remove": _vm.handleRemove,
                        data: _vm.token,
                        "before-upload": _vm.getToken,
                        "on-success": _vm.uploadSuccess,
                        "file-list": _vm.fileList
                      }
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "原因", prop: "appealExplain" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      placeholder: "请控制在500个字内",
                      clearable: ""
                    },
                    model: {
                      value: _vm.modal.appealExplain,
                      callback: function($$v) {
                        _vm.$set(_vm.modal, "appealExplain", $$v)
                      },
                      expression: "modal.appealExplain"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addModalFun } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申诉原因",
            visible: _vm.dialogVisibleResult,
            width: "50%",
            "before-close": _vm.handleCloseResult
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleResult = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "图片：" } },
                [
                  _vm._l(_vm.result.appealExtend, function(item, key) {
                    return [
                      _c("img", {
                        staticClass: "form-img",
                        attrs: { src: item }
                      })
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "原因：" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.result.appealExplain) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "结果：" } },
                [
                  _vm.result.handleState == "Appealing"
                    ? [_vm._v("申诉中")]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.handleState == "AppealSuccess"
                    ? [_vm._v("申诉成功")]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.handleState == "AppealUnSuccess"
                    ? [_vm._v("申诉失败")]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.result.handleExplain) +
                    "\n        "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseResult } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b23d736", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b23d736","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/blacklist.vue
// module id = 1155
// module chunks = 0